import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { intakeQuestionnaireActions } from '../../../../store';
import {
  hasChildBackgroundErrors,
  hasChildFieldValue,
  hasChildScheduleErrors,
  isChildBackgroundComplete,
} from '../../../common';
import { INTAKE_TAB_IDS } from '../constants';
import {
  getCurrentChildBehaviorIssuesFormValue,
  hasIntakeChildBehaviorIssuesErrors,
} from '../components/forms/clientInfo/utils';

import type { AppDispatch, RootState } from '../../../../store';

export default function useInitializeIntakeChildTabStatus() {
  const dispatch = useDispatch<AppDispatch>();
  const nestedIntakePath = useParams()['*'];
  const childInfo = useSelector(
    (state: RootState) => state.intakeQuestionnaire.intakeQuestionnaireDetails?.child_info,
  );
  const notAttendingSchool = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.not_attending_school ?? false,
  );

  useEffect(() => {
    const childBehaviorIssues =
      getCurrentChildBehaviorIssuesFormValue() ?? childInfo?.child_behavior_issues ?? '';
    const hasScheduleErrors = hasChildScheduleErrors(childInfo, notAttendingSchool);
    const hasBehaviorIssuesErrors = hasIntakeChildBehaviorIssuesErrors(
      childInfo,
      childBehaviorIssues,
    );
    dispatch(
      intakeQuestionnaireActions.updateIntakeTabStatus({
        tabId: INTAKE_TAB_IDS.CHILD,
        status: {
          error:
            (hasChildFieldValue(childInfo) || Boolean(childBehaviorIssues.trim())) &&
            (hasChildBackgroundErrors(childInfo) || hasScheduleErrors || hasBehaviorIssuesErrors),
          success:
            isChildBackgroundComplete(childInfo) && !hasScheduleErrors && !hasBehaviorIssuesErrors,
        },
      }),
    );
  }, [childInfo, dispatch, nestedIntakePath, notAttendingSchool]);
}
